import * as React from 'react';
import { motion } from 'framer-motion';
import Button from '../Button/Button.js';

const animations = {
    expanded: {
        height: 'auto',
        overflow: 'hidden',
        transition: {
            ease: 'easeOut',
            duration: 0.3
        }
    },
    collapsed: {
        height: '0px',
        overflow: 'hidden',
        transition: {
            ease: 'easeIn',
            duration: 0.3
        }
    }
};
const Expander = ({ children , className , id , showMoreLabel , showLessLabel , onExpandCallback , isInitiallyExpanded =false  })=>{
    const [isExpanded1, toggleIsExpanded] = React.useReducer((isExpanded)=>!isExpanded
    , isInitiallyExpanded);
    React.useEffect(()=>{
        onExpandCallback(isExpanded1);
    }, [
        isExpanded1,
        onExpandCallback
    ]);
    const toggleText = isExpanded1 ? showLessLabel : showMoreLabel;
    const toggleIcon = isExpanded1 ? 'minus' : 'plus';
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "expander",
        "data-t": "expander"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        id: `expander-${id}`,
        "data-t": "motion-expander",
        initial: animations.collapsed,
        animate: isExpanded1 ? animations.expanded : animations.collapsed,
        "aria-hidden": !isExpanded1,
        className: className
    }, children), /*#__PURE__*/ React.createElement(Button, {
        className: "expander__toggle",
        variant: "outline",
        onClick: toggleIsExpanded,
        "aria-expanded": isExpanded1,
        "aria-controls": `expander-${id}`,
        caption: toggleText,
        icon: toggleIcon
    }));
};

export { Expander as default };
//# sourceMappingURL=Expander.js.map
